import { Document, Page, Text, View, StyleSheet, Font } from "@react-pdf/renderer";

// Font registration
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});

// Utility to chunk array
function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}



const MonthWiseReport = ({ data  }) => {
  const rowChunks = chunkArray(data.data, 35); // Split data into chunks of 30 rows

  const month = data.month;
  const year = data.year;


  // const styles = StyleSheet.create({
  //   col: {
  //     display: "flex",
  //     flexDirection: "row",
  //   },
  // });

  return (
    <Document>
      {rowChunks.map((chunk, chunkIdx) => (
        <Page
          key={chunkIdx}
          size="A4"
          style={{ padding: 30, paddingRight: 160, paddingLeft: 100, fontSize: 10 }}
        >
          {/* Header */}
          <View style={{ fontSize: 9, marginBottom: 10 }}>
            <Text style={{ fontFamily: "Poppins", fontWeight: "bold", fontSize: 9 }}>
              Suvidya Institute of Technology Pvt. Ltd.
            </Text>
          </View>

          {/* Title */}
          <View
            style={{
              marginBottom: "2%",
              height: "3.2%",
              border: "1px solid black",
              fontSize: "10px",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              gap: "30px",
            }}
          >
            <Text style={{ fontFamily: "Poppins", fontWeight: "600", fontSize: 9, paddingRight: 10 }}>
              Inquiry Report for month
            </Text>
            <Text style={{ fontFamily: "Poppins", fontSize: 9 }}>{month} - {year}</Text>
          </View>

          {/* Table Header */}
          <View
            style={{
              border: "1px solid black",
              fontSize: "10px",
              textAlign: "center",
              width: "100%",
              height: "2.2%",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                borderRight: "1px solid black",
                width: "11%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 600 }}>
                S.No.
              </Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                width: "59%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 600 }}>
                Training Programme
              </Text>
            </View>
            <View
              style={{
                width: "30%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 600 }}>
                Students
              </Text>
            </View>
          </View>

          {/* Table Rows */}
          {chunk.map((row, idx) => (
            <View
              key={idx}
              style={{
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                borderLeft: "1px solid black",
                fontSize: "10px",
                width: "100%",
                height: "2.5%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  borderRight: "1px solid black",
                  width: "11%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins" }}>{idx + 1}</Text>
              </View>
              <View
                style={{
                  borderRight: "1px solid black",
                  width: "59%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  paddingLeft: 10
                }}
              >
                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins" }}>{row.Course_Name}</Text>
              </View>
              <View
                style={{
                  width: "30%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins" }}>{row.Student_Count}</Text>
              </View>
            </View>
          ))}

          {/* Total Row */}
          {chunkIdx === rowChunks.length - 1 && (
            <View
              style={{
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                borderLeft: "1px solid black",
                fontSize: "10px",
                textAlign: "center",
                width: "100%",
                height: "2.2%",
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  borderRight: "1px solid black",
                  width: "70%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  paddingRight: 10,
                }}
              >
                <Text style={{ fontSize: 9, fontFamily: "Poppins", fontWeight: 600 }}>Total Students:</Text>
              </View>
              <View
                style={{
                  width: "30%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins" }}>
                  {data.data.reduce((sum, row) => sum + row.Student_Count, 0)}
                </Text>
              </View>
            </View>
          )}
        </Page>
      ))}
    </Document>
  );
};

export default MonthWiseReport;